import React from 'react';
import { Link } from 'react-router-dom';
import FormItem from '../../general/formitem.js';
import { FilePond } from 'react-filepond';
import 'filepond/dist/filepond.min.css';

export default class CourseManagement extends React.Component
{
    constructor(props)
    {
        super(props);
        this.createClick = this.createClick.bind(this);
        this.importClick = this.importClick.bind(this);
        this.cancelClick = this.cancelClick.bind(this);
        this.inputChanged = this.inputChanged.bind(this);
        this.getDefaultFormData = this.getDefaultFormData.bind(this);
        this.state = {
            loaded: false,
            error: "",
            create: false,
            import: false,
            submissionAttempted: false,
            formData: this.getDefaultFormData(),
            courses: [],
            validationErrors: [],
            files: [],
            resultMsg: "",
            resultSucc: false
        }
    }
    componentDidMount()
    {
        this.loadCourses();
    }
    getDefaultFormData()
    {
        return {
            courseID: 0,
            courseName: "",
            courseDescription: "",
            coursePrice: 0.00
        }
    }
    loadCourses()
    {
        this.props.api.send({
            controller: "Course",
            action: "GetCourses",
            method: "get",
            success: (result) => {
                result.success ?
                    this.setState({loaded: true, courses: result.courses}) :
                    this.setState({loaded: true, error: result.message})
            },
            error: (err) => {
                this.setState({loaded: true, error: "Unable to load courses.  Please try again later."})
            }
        });
    }
    editClick(e, cid)
    {
        e.preventDefault();
        this.setState({loaded: false});
        this.props.api.send({
            controller: "Course",
            action: "GetCourse",
            method: "post",
            body: JSON.stringify({courseID: cid}),
            success: (result) => {
                if (result.courseID === 0)
                {
                    this.setState({loaded: true, error: "An error occurred while fetching course data."});
                    return;
                }
                this.setState({
                    loaded: true,
                    create: true,
                    error: "",
                    formData: {
                        courseID: result.courseID,
                        courseName: result.courseName,
                        courseDescription: result.courseDescription,
                        coursePrice: result.coursePrice.toFixed(2)
                    }
                })
            },
            error: (err) => {
                this.setState({loaded: true, error: "An error occurred while fetching course data."})
            }
        })
    }
    deleteClick(e, cid)
    {
        e.preventDefault();
        if (window.confirm("Are you sure you want to delete this course?"))
        {
            this.setState({loaded: false});
            this.props.api.send({
                controller: "Course",
                action: "DeleteCourse",
                method: "post",
                body: JSON.stringify({courseID: cid}),
                success: (result) => {
                    this.setState({
                        loaded: true,
                        create: false,
                        error: "",
                        formData: this.getDefaultFormData()
                    })
                    this.loadCourses();
                },
                error: (err) => {
                    this.setState({loaded: true, error: "An error occurred while deleting this course."})
                }
            })
        }
    }
    createClick(e)
    {
        e.preventDefault();
        this.setState({create: true, import: false});
    }
    cancelClick(e)
    {
        e.preventDefault();
        this.setState({
            loaded: true,
            create: false,
            import: false,
            error: "",
            formData: this.getDefaultFormData()
        })
    }
    //onFileChange(onFileChange, file) {
    //    if (file.file !== null) {
    //        this.setState({ files: file.file });
    //    }
    //}
    importClick(e) {
        e.preventDefault();
        this.setState({ import: true, create: false });
    }
    importCourse(error, file)
    {
        this.setState({ loaded: false });
        let f = new FormData();
        f.append("File", file.file)
        this.props.api.send({
            controller: "Scorm",
            action: "ImportCourse",
            method: "post",
            body: f,
            headers: { 'Content-Type': 'multipart/form-data' },
            fileUpload: true,
            success: (result) => {
                if (result.success) {
                    this.setState({
                        loaded: true,
                        resultMsg: result.message,
                        resultSucc: "lmssuccess"
                    });
                }
                else {
                    this.setState({
                        loaded: true,
                        resultMsg: result.message,
                        resultSucc: "lmsvalidationerror"
                    });
                }
            },
            error: (result) => {
                this.setState({
                    loaded: true,
                    resultMsg: "Unable to import course due to internal error! Please try again later!",
                    resultSucc: "lmsvalidationerror"
                });
                console.log(result);
            }
        })
    }
    validate()
    {
        if (this.state.submissionAttempted)
        {
            var errors = [];
            if (this.state.formData.courseName === "")
            {
                errors.push({message: "Course name is required.", element: "courseName"});
            }
            if (this.state.formData.courseDescription === "")
            {
                errors.push({message: "Course description is required.", element: "courseDescription"});
            }
            if (isNaN(this.state.formData.coursePrice) || this.state.formData.coursePrice === "")
            {
                errors.push({message: "Course price must be numeric.", element: "coursePrice"});
            }
            this.setState({validationErrors: errors});
            if (errors.length > 0)
            {
                return false;
            }
        }
        return true;
    }
    submitCourse(e)
    {
        e.preventDefault();
        this.setState({submissionAttempted: true}, () => {
            if (!this.validate())
            {
                return;
            }
            this.setState({loaded: false});
            this.props.api.send({
                controller: "Course",
                action: "SaveCourse",
                method: "post",
                body: JSON.stringify(this.state.formData),
                success: (result) => {
                    if (!result.success)
                    {
                        this.setState({loaded: true, error: result.message});
                    }
                    this.setState({
                        loaded: true,
                        create: false,
                        error: "",
                        formData: this.getDefaultFormData()
                    });
                    this.loadCourses();
                },
                error: (err) => {
                    this.setState({loaded: true, errorMessage: "An error occurred while saving this course."})
                }
            })
        });
    }
    inputChanged(e)
    {
        var data = this.state.formData;
        data[e.target.name] = e.target.value;
        this.setState({formData: data}, () => this.validate())
    }
    render()
    {
        const courserows = this.state.courses.map((c) => 
            <tr key={c.courseID}>
                <td>{c.courseName}</td>
                <td>
                    {c.courseDescription.length < 120 ? c.courseDescription : c.courseDescription.substring(0, 120) + "..."}
                </td>
                <td>
                    ${c.coursePrice.toFixed(2)}
                </td>
                <td style={{width: "400px"}}>
                    <Link className="lmsbutton" to="/" onClick={(e) => this.editClick(e, c.courseID)}>Edit</Link>
                    <Link className="lmsbutton" to={"/CourseUsers/" + c.courseID}>Users</Link>
                    <Link className="lmsbutton" to={"/CourseContentManagement/" + c.courseID }>Content</Link>
                    <Link className="lmsbutton" to={"/CoursePricingManagement/" + c.courseID }>Pricing</Link>
                    <Link className="lmsbutton" to="/" onClick={(e) => this.deleteClick(e, c.courseID)}>Delete</Link>
                </td>
            </tr>
        )
        return (
            <div className="lmsdisplayarea">
                <h3>Manage Courses</h3>
                { this.state.loaded ? (
                <div>
                    <p>
                        <a className="lmsbutton" href="/" onClick={(e) => this.createClick(e)}>Create Course</a>
                        <a className="lmsbutton" href="/" onClick={(e) => this.importClick(e)}>Import Course</a>
                    </p>
                    {this.state.create ? (
                        <div className="lmsformbody">
                            <form className="lmsforminner" method="post" onSubmit={(e) => this.submitCourse(e)}>
                                <FormItem label="Course Name" name="courseName" type="text"
                                    inputChanged={this.inputChanged} value={this.state.formData.courseName}
                                    validationErrors={this.state.validationErrors} />
                                <FormItem label="Course Description" name="courseDescription" type="textarea"
                                    inputChanged={this.inputChanged} value={this.state.formData.courseDescription}
                                    validationErrors={this.state.validationErrors} />
                                <FormItem label="Course Base Price" name="coursePrice" type="text"
                                    inputChanged = {this.inputChanged} value={this.state.formData.coursePrice}
                                    validationErrors={this.state.validationErrors} />
                                <div className="lmsvalidationerror">
                                    <span>{this.state.validationErrors.map((err) =>
                                        <p key={err.element}>{err.message}</p>
                                    )}
                                    <div className="lmsformfooter">
                                        <input type="button" name="cancel" value="Cancel" className="lmsbutton" onClick={this.cancelClick} />
                                        <input type="submit" name="save" value="Save" className="lmsbutton" />
                                    </div>
                                    </span>
                                </div>
                            </form>
                        </div>
                        ) : null}
                        {this.state.import ? (
                            <div className="lmsformbody">
                                <label>All Imports will be in ZIP format to be accepted. Please assure they are SCORM compliant, or they will not be accepted.</label>
                                <br />
                                <FilePond
                                    ref={ref => this.pond = ref}
                                    files={this.state.files}
                                    maxFiles={1}
                                    onaddfile={(error, file) => this.importCourse(error, file)}
                                />
                                <br /><br /><br /><br />
                                <input type="button" name="cancel" value="Cancel" className="lmsbutton" onClick={this.cancelClick} />
                                <input type="submit" className="lmsbutton" value="Submit" />
                                {this.state.resultMsg ? <label className={this.state.resultSucc}>{this.state.resultMsg}</label> : null}
                            </div>
                        ): null}
                    <div className="lmstablecontainer">
                        <table className="lmstable">
                            <thead>
                                <tr>
                                    <th>Course Name</th>
                                    <th>Course Description</th>
                                    <th>Course Base Price</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {courserows}
                            </tbody>
                        </table>
                    </div>
                    </div>
                ) : (
                    <div className="lmscenter"><img src="/images/spinner.svg" alt="Loading..." /></div>
                )}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/course/management/coursemanagement.js